import { UtilsService } from 'src/app/services/utils.service';
import { ErrorResponse } from 'src/app/models/error.model';
import { AuthService } from 'src/app/services/auth.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
    templateUrl: './change-email-dialog.component.html',
    styleUrls: ['./change-email-dialog.component.scss']
})
export class ChangeEmailDialogComponent implements OnInit {

    changeEmailFG = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.email, Validators.required]),
        confirm: new UntypedFormControl('', [Validators.required, control => this.changeEmailFG && control.value !== this.changeEmailFG.value.email ? { notEquals: true } : undefined]),
    });

    constructor(
        private authService: AuthService,
        private utilsService: UtilsService,
        public dialogRef: MatDialogRef<ChangeEmailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { email: string }
    ) { }

    ngOnInit(): void {
    }

    cancel() {
        this.dialogRef.close(false);
    }

    submit() {
        if (this.changeEmailFG.valid) {
            this.authService.changeEmail(this.data.email, this.changeEmailFG.value.email).subscribe(_ => {
                this.utilsService.alert('Email cambiado correctamente', 'Se ha enviado un email al nuevo correo para regenerar la contraseña.')
                    .afterClosed().subscribe(() => this.dialogRef.close(true));
            }, (error: ErrorResponse) => this.utilsService.alert('Error al cambiar email', error?.error?.descripcion));
        }
    }
}
